import client from './client'

export default client
export * from './client' // auto generated by yarn build:config
